// Actions LoginPopup
export const ActionsLoginPopup = {
	SHOW_MODAL_VERIFY_EMAIL: "show_modal_verify_email",
};

// Function if LoadLoginPopup
export function showModalVerify(params = {}) {

	return { type: ActionsLoginPopup.SHOW_MODAL_VERIFY_EMAIL, ...params };

}
